import { Blockquote } from '@mantine/core';
import { TextFragment } from './TextFragment';
import { resizeProperty } from '@/helpers';

export function Quote({ item, formValues = {}, containerWidth }) {
  return (
    <Blockquote
      py={resizeProperty(containerWidth, 32)}
      px={resizeProperty(containerWidth, 38)}
      mb="md"
      style={{
        color: formValues.body_font_color,
        fontFamily: formValues.body_font_family,
        fontWeight: formValues.body_font_weight,
        fontSize: resizeProperty(containerWidth, formValues.body_font_size),
        textAlignment: formValues.body_alignment,
        fontStyle: formValues.body_italic ? 'italic' : 'normal',
        textDecoration:
          `${formValues.body_underlined ? 'underline ' : ''}${formValues.body_strikethrough ? 'line-through' : ''}`.trim(),
      }}
    >
      {item.richText.map((d, index) => (
        <TextFragment
          fragment={d}
          key={index}
          formValues={formValues}
          containerWidth={containerWidth}
        />
      ))}
    </Blockquote>
  );
}
